import { Box, Typography, Divider } from '@mui/material';

interface BrandDetailProps {
  brand: any;
}

const BrandDetail = ({ brand }: BrandDetailProps) => {
  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography
            variant="subtitle2"
            color="text.secondary"
            sx={{ width: '140px', fontSize: '14px' }}
          >
            Brand Name
          </Typography>
          <Box
            sx={{
              flex: 1,
              border: '1px solid #E0E0E0',
              borderRadius: '6px',
              minHeight: '40px',
              display: 'flex',
              alignItems: 'center',
              padding: '8px 12px',
            }}
          >
            <Typography sx={{ color: 'text.main', fontSize: '14px' }}>
              {brand.name ? brand.name : 'N/A'}
            </Typography>
          </Box>
        </Box>

        <Divider />

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 2,
            width: '100%',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography
              variant="subtitle2"
              color="text.main"
              sx={{ fontSize: '14px', fontWeight: 500 }}
            >
              Brand Contact Details
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              width: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                width: '100%',
              }}
            >
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ width: '140px', fontSize: '14px' }}
              >
                Name
              </Typography>
              <Box
                sx={{
                  flex: 1,
                  border: '1px solid #E0E0E0',
                  borderRadius: '6px',
                  minHeight: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  padding: '8px 12px',
                }}
              >
                <Typography sx={{ color: 'text.main', fontSize: '14px' }}>
                  {brand.poc_at_brand ? brand.poc_at_brand : 'N/A'}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                width: '100%',
              }}
            >
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ width: '140px', fontSize: '14px' }}
              >
                Email
              </Typography>
              <Box
                sx={{
                  flex: 1,
                  border: '1px solid #E0E0E0',
                  borderRadius: '6px',
                  bgcolor: '#fff',
                  minHeight: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  padding: '8px 12px',
                }}
              >
                <Typography sx={{ color: 'text.main', fontSize: '14px' }}>
                  {brand.poc_at_email ? brand.poc_at_email : 'N/A'}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                width: '100%',
              }}
            >
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ width: '140px', fontSize: '14px' }}
              >
                Role
              </Typography>
              <Box
                sx={{
                  flex: 1,
                  border: '1px solid #E0E0E0',
                  borderRadius: '6px',
                  bgcolor: '#fff',
                  minHeight: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  padding: '8px 12px',
                }}
              >
                <Typography sx={{ color: 'text.main', fontSize: '14px' }}>
                  {brand.poc_role ? brand.poc_role : 'N/A'}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                width: '100%',
              }}
            >
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ width: '140px', fontSize: '14px' }}
              >
                Contact
              </Typography>
              <Box
                sx={{
                  flex: 1,
                  bgcolor: '#fff',
                  borderRadius: '6px',
                  border: '1px solid #E0E0E0',
                  minHeight: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  padding: '8px 12px',
                }}
              >
                <Typography sx={{ color: 'text.main', fontSize: '14px' }}>
                  {brand.poc_contact ? brand.poc_contact : 'N/A'}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default BrandDetail;
